import axios from 'axios';

const baseUrl =
  process.env.REACT_APP_QCX_API_BASE_URL! +
  '/followup/report/processos-abertos-averbados';

export const generateProcessosAbertosAverbadosReport = async (
  token: string,
  unidadeId: string,
  tenantIds: string[],
  clientIds: string[],
  startDate: string,
  endDate: string
): Promise<string | null> => {
  const params = new URLSearchParams();
  params.set('tenantId', tenantIds.join(','));
  if (clientIds.length > 0) {
    params.set('clientesId', clientIds.join(','));
  }
  params.set('insertionDateRange', `${startDate};${endDate}`);

  try {
    const response = await axios.get(`${baseUrl}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        quickcomexTenant: unidadeId,
      },
      responseType: 'blob',
      // faz com que o Axios NÃO jogue para o catch em status ≥400
      validateStatus: () => true,
    });

    // sucesso
    if (response.status === 200) {
      const file = new File([response.data], 'processos-abertos-averbados.xlsx', {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
      return null;
    }

    // erro do servidor: extrai o texto da blob
    const errText = await response.data.text();
    return errText || 'Erro ao gerar o relatório.';

  } catch (networkError) {
    // caso de falha de rede / timeout etc
    return 'Não foi possível conectar ao servidor para gerar o relatório.';
  }
};
